import { useEffect, useState } from "react";
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import colorPalette from "../../../Palette";
import { formatToHhMmSs } from "../../../newUtils/timeFormatter";
import API from "../../API";
import TrendReportTopIssuesChart from "./TrendReportTopIssuesChart";
import TrendReportDrilldownChart from "./TrendReportDrilldownChart";

const TrendReportDrilldown = (props) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [max_duration, setMaxDuration] = useState(1);
    const [parsedData, setParsedData] = useState([]);
    
    
    


    useEffect(() => {
        if (props.open) {
            setLoading(true);
            setError(null);
            setData(null);
            setMaxDuration(1);
            setParsedData([]);
            getReasonRuns();
        }
    }, [props]);

    useEffect(() => {
        // getReasonRuns();
    }, [])

    const getReasonRuns = () => {
        setLoading(true)
        
        let params = {
            path: 'get_trend_reason_runs',
            data: {
                start_range_date: `${props.date_from.toISOString().slice(0, -5)}Z`,
                end_range_date: `${props.date_to.toISOString().slice(0, -5)}Z`,
                granularity: props.granularity,
                line_id: props.line_id,
                shift_id: props.shift_id,
                // number_of_trends: props.number_of_trends,
                reason_id: props.reason_id,
            },
            success: onGetReasonRunsSuccess,
            error: onGetReasonRunsError
        };
        if (props.reason_id === -1 || (props.reason_id === null && props.reason !== 'Slow Running' && props.reason !== 'Unreported')) {
            onGetReasonRunsError()
        }
        API.c(params);
    };

    const onGetReasonRunsSuccess = data => {
        setError(null);
        
        let info = [...data];
        // info.sort((a, b) => {
        //     return getLostTime(b) - getLostTime(a);
        // });

        // let arr = [];
        // info.forEach(e => {
        //     arr.push(getLostTime(e));
        // });

        // let max
        // if (arr && arr.length > 0) {
        //     max = arr.reduce(function (a, b) {
        //         return Math.max(a, b);
        //     });
        // }
        // else {
        //     setLoading(false);
        //     setData(null)
        //     setMaxDuration(1);
        //     setParsedData([]);
        // }
        setLoading(false);
        setData(info);
        // setMaxDuration(max);

        let newParsedData = [];

        // if (info && info.length > 0) {
        //     info.forEach(r => {
        //         if (r.downtime_reason_name === props.reason) {
        //             newParsedData.push(r);
        //         }
        //     });
        // }
        setParsedData(data);

    };

    const onGetReasonRunsError = err => {
        setLoading(false);
        setError('Error loading runs with selected lost time reason');
    };

    const renderLostTimeBar = r => {
        let duration = 0;

        switch (r.downtime_reason_name) {
            case 'Slow Running':
                duration = r.total_slow_running_seconds;
                break;
            case 'Waste':
                duration = r.total_waste_seconds;
                break;
            case 'Rework':
                duration = r.total_rework_seconds;
                break;
            default:
                duration = r.total_reason_downtime_seconds;
                break;
        }

        let width = (Math.abs(duration) / max_duration) * 100;

        return (
            <div style={{ width: width + '%', height: '24px', borderRadius: "2px", background: duration >= 0 ? colorPalette.error[60] : '#A5CF9B' }}>
                &nbsp;
            </div>
        );
    };

    return (
        <div style={{ padding: "24px 24px 24px 24px", marginTop: "20px", width: "98%", transition: "all 2s ease-out", minHeight: props.open ? "278px" : "0px !important", display: props.open ? "block" : "none" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "24px", padding: "20px 18px 20px 0px" }}>
                <p style={{ fontWeight: "400" }}>Trending issues: <span style={{ fontWeight: "500" }}> {props.reason}</span></p>
                <CloseIcon sx={{ cursor: "pointer" }} onClick={props.hideModal} />
            </div>
            <hr style={{ margin: "0px -24px 0px -24px", border: "none", height: "1px", background: "#D9D9D9" }} />
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "140px" }}>
                    <CircularProgress />
                </div>
            ) : parsedData.length > 0 ? (
                <TrendReportDrilldownChart granularity={props.granularity} granular_efficiency_range_list={parsedData ? parsedData : []} />
            ) : (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "140px" }}>
                    No runs available
                </div>
            )}
            {/* <div style={{ marginTop: "60px" }}> */}
            {/* </div> */}
        </div>
    )
}

export default TrendReportDrilldown;